import AdvisoryMessage from '@polleverywhere/toolkit/components/advisory_message'
import _ from 'underscore'
import './style.scss'

function integrationModeMessageOptions (view, model) {
  let opts, handler

  const subject = model.get('title') || 'Security update required'
  const message = model.get('message') || 'Please download the latest version at https://www.polleverywhere.com/app'

  switch (model.get('status')) {
    case 'unsupported':
      opts = {
        icon: 'error',
        subject,
        message
      }

      break

    case 'warning':
      opts = {
        icon: 'error',
        subject,
        message,
        resolutionLabel: 'Continue'
      }

      handler = () => {
        view.remove()
      }

      break
  }

  return { opts, handler }
}

function standaloneModeOptions (view, model, options = {}) {
  let opts, handler

  if (model.get('status') === 'unsupported') {
    opts = {
      icon: 'error',
      subject: model.get('title'),
      message: model.get('message'),
      resolutionLabel: options.resolutionLabel
    }

    handler = options.resolutionHandler
  }

  return { opts, handler }
}

export default class BrowserCheck extends Backbone.View {
  get className () { return 'component-browser-check' }

  initialize (options = {}) {
    this.options = _.defaults(options, {
      mode: 'standalone',
      appName: 'Poll Everywhere Presenter'
    })

    this.listenTo(this.model, 'change:status', this.render.bind(this))
  }

  render () {
    this.view && this.view.remove()

    let opts, handler
    if (this.options.mode === 'integration') {
      ({ opts, handler } = integrationModeMessageOptions(this, this.model))
    } else {
      ({ opts, handler } = standaloneModeOptions(this, this.model, this.options))
    }

    if (opts) {
      this.view = new AdvisoryMessage(opts)

      if (handler) {
        this.view.on('resolve', handler)
      }

      this.$el.append(this.view.render().$el)
    }

    return this
  }

  check () {
    if (this.options.mode === 'integration') {
      this.model.fetch({
        url: '/api/browser_check?app=presenter'
      })
    } else {
      this.model.set({
        status: 'supported'
      })
    }
  }

  remove () {
    this.view && this.view.remove()
    super.remove()
  }
}
